import React, { useRef } from "react";
import { Button } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useAppSelector } from "../../../../../../app/hooks";
import { PrintableIncidentReport } from "./PrintableIncidentReport";

function IncidentExportButtons() {
    const variance = useAppSelector(
        (state) => state.varianceRequest.varianceRequest
    );
    const pdfExportComponent = useRef<PDFExport>(null);

    const handleDownloadPdf = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };

    const fileName = variance.incidentDisplayNumber
        ? `Incident-${variance.incidentDisplayNumber}.pdf`
        : "Incident-Report.pdf";

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                size="small"
                startIcon={<PictureAsPdf />}
                onClick={handleDownloadPdf}
            >
                PDF
            </Button>
            <div style={{ position: "absolute", left: "-100000px", top: 0, width: "800px", overflow: "hidden", pointerEvents: "none" }}>
                <PDFExport
                    paperSize="letter"
                    margin="1.5cm"
                    ref={pdfExportComponent}
                    fileName={fileName}
                >
                    <PrintableIncidentReport variance={variance} />
                </PDFExport>
            </div>
        </React.Fragment>
    );
}

export { IncidentExportButtons };
